export default {
  'bonus.templateName': 'Template Name',
  'bonus.operationTime': 'Update Time',
  'bonus.operation': 'Operate',
  'bonus.unredeemed': 'Not Yet',
  'bonus.redeemed': 'Redemmed',
  'bonus.expired': 'Expired',
  'bonus.reversed': 'Voided',
  'bonus.exchangeCode': 'Redeemption Code',
  'bonus.cash': 'Cash',
  'bonus.language': 'Language',
  'bonus.redirectLink': 'Redirect URL',
  'bonus.bonusId': 'Prize ID',
  'bonus.lobbyId': 'Lobby ID',
  'bonus.roomId': 'Room ID',
  'bonus.accountId': 'User ID',
  'bonus.bonusType': 'Prize Type',
  'bonus.redemptionCode': 'Redemption Code',
  'bonus.amount': 'Amount',
  'bonus.createTime': 'Create Time',
  'bonus.redemptionCodeExpiryTime': 'Redemption Expire Time',
  'bonus.redemptionTime': 'Redeem Time',
  'bonus.bonusStatus': 'Prize Status',
  'bonus.action': 'Operate',
  'bonus.changeStatus': 'Update Status',
  'bonus.batchUpdateStatus': 'Bulk Update',
  'bonus.selectAtLeastOneRecord': 'Required to select at least 1 record',
  'bonus.selectOperation': 'Please select an option',
  'bonus.pleaseSelect': 'Please select',
  'bonus.bonusInquiry': 'Prize List',
};
